import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { TIPTAP_APP_EMBED_TYPE } from "./../../ricos-content/index.js";
import { createRicosNodeExtension } from "./../../plugin-commons/index.js";
import { AppEmbed as Component } from "./component.js";
const tiptapExtensions = [
  createRicosNodeExtension({
    groups: ["draggable", "not-overtypable", "resizable"],
    type: "react-node",
    reconfigure: (config, _extensions, _props, settings) => ({
      ...config,
      addOptions: () => settings
    }),
    Component,
    name: TIPTAP_APP_EMBED_TYPE,
    createExtensionConfig() {
      const HOVER_PREVIEW_PLUGIN_KEY = new PluginKey("verticalEmbedHoverPreview");
      return {
        name: this.name,
        group: "block layoutCellContent collapsibleListItemBodyContent tableCellContent",
        selectable: true,
        draggable: true,
        addAttributes: () => ({
          type: null,
          name: null,
          url: null,
          image: null,
          itemId: null,
          hideImage: null,
          hidePrice: null,
          hideButton: null,
          hideRibbon: null,
          hideDescription: null,
          hideDateTime: null,
          hideLocation: null,
          hideDuration: null,
          buttonStyles: null,
          imageStyles: null,
          ribbonStyles: null,
          cardStyles: null,
          bookingData: null,
          eventData: null,
          containerData: null,
          loading: null,
          error: null,
          pricingData: null
        }),
        addCommands() {
          return {
            setVerticalEmbedButtonHoverPreview: (applyPreview) => ({ tr, dispatch }) => {
              dispatch?.(tr.setMeta(HOVER_PREVIEW_PLUGIN_KEY, applyPreview));
              return true;
            }
          };
        },
        addProseMirrorPlugins() {
          return [
            new Plugin({
              key: HOVER_PREVIEW_PLUGIN_KEY,
              state: {
                init() {
                  return { applyPreview: false };
                },
                apply(tr, value) {
                  const applyPreview = tr.getMeta(HOVER_PREVIEW_PLUGIN_KEY);
                  if (applyPreview === void 0) {
                    return value;
                  }
                  return { applyPreview };
                }
              },
              props: {
                decorations(state) {
                  const { applyPreview } = HOVER_PREVIEW_PLUGIN_KEY.getState(state);
                  const { from, to } = state.selection;
                  if (!applyPreview) {
                    return null;
                  }
                  return DecorationSet.create(state.doc, [
                    Decoration.node(from, to, {
                      class: "forced-hover"
                    })
                  ]);
                }
              }
            })
          ];
        }
      };
    }
  })
];
export {
  tiptapExtensions
};
//# sourceMappingURL=tiptap.js.map
